import { render, staticRenderFns } from "./BuildPageCard.vue?vue&type=template&id=6565631f"
import script from "./BuildPageCard.vue?vue&type=script&lang=js"
export * from "./BuildPageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports